var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { DivTag } from '../../Utils/AtomicTag';
import { getScrollTop } from '../../Utils/browser';
var getOffsetTop = function (el) {
    var offsetTop = el.clientTop || 0;
    while (el) {
        offsetTop += el.offsetTop || 0;
        el = el.offsetParent;
    }
    return offsetTop;
};
var Affix = /** @class */ (function (_super) {
    __extends(Affix, _super);
    function Affix(props) {
        var _this = _super.call(this, props) || this;
        _this.handleContainerEvent = function (_a) {
            var scrollTop = _a.scrollTop, eventSource = _a.eventSource;
            if (_this.content && _this.placeholder.current) {
                var parent_1 = _this.props.target();
                var relative = parent_1 !== document.body;
                var _b = _this.props, offsetTop = _b.offsetTop, offsetBottom = _b.offsetBottom, initFixed = _b.initFixed, outFixed = _b.outFixed;
                var preventingStickyStateChanges = false;
                var contentClientRect = _this.content.getBoundingClientRect();
                var calculatedHeight = contentClientRect.height;
                if (relative) {
                    preventingStickyStateChanges = eventSource !== parent_1;
                }
                var wasSticky = !!_this.state.isSticky;
                var isSticky = false;
                var setStyle = {};
                if (preventingStickyStateChanges) {
                    isSticky = wasSticky;
                }
                if (!preventingStickyStateChanges && relative) {
                    // 相对容器的滚动
                    if (offsetBottom >= 0) {
                        setStyle.bottom = offsetBottom;
                        isSticky =
                            scrollTop <
                                _this.placeholder.current.offsetTop -
                                    parent_1.offsetTop +
                                    calculatedHeight -
                                    parent_1.clientHeight;
                    }
                    if (offsetTop >= 0) {
                        setStyle.top = offsetTop;
                        isSticky = scrollTop > _this.placeholder.current.offsetTop - parent_1.offsetTop;
                    }
                    if (isSticky) {
                        setStyle.position = 'absolute';
                        setStyle.transform = 'translateZ(0)';
                    }
                    else {
                        setStyle.position = 'static';
                        setStyle.transform = 'none';
                    }
                }
                else if (!relative && eventSource == parent_1) {
                    if (offsetBottom >= 0 && !initFixed) {
                        setStyle.bottom = offsetBottom;
                        isSticky = scrollTop > getOffsetTop(_this.placeholder.current) + calculatedHeight;
                    }
                    if (offsetBottom >= 0 && initFixed) {
                        setStyle.bottom = offsetBottom;
                        isSticky =
                            scrollTop + _this.clientWidth < getOffsetTop(_this.placeholder.current) + calculatedHeight;
                    }
                    if (offsetTop >= 0 && !initFixed) {
                        setStyle.top = offsetTop;
                        isSticky = scrollTop > getOffsetTop(_this.placeholder.current);
                    }
                    if (offsetTop >= 0 && initFixed) {
                        setStyle.top = offsetTop;
                        if (outFixed) {
                            isSticky = true;
                        }
                        else {
                            isSticky = scrollTop + _this.clientWidth < getOffsetTop(_this.placeholder.current);
                        }
                    }
                    if (isSticky) {
                        setStyle.position = 'fixed';
                        setStyle.transform = 'translateZ(0)';
                    }
                    else {
                        setStyle.position = 'static';
                        setStyle.transform = 'none';
                    }
                }
                var style = __assign(__assign({}, _this.state.style), setStyle);
                _this.setState({
                    isSticky: isSticky,
                    wasSticky: wasSticky,
                    calculatedHeight: calculatedHeight,
                    style: style,
                });
            }
        };
        _this.state = {
            isSticky: false,
            wasSticky: false,
            style: {},
        };
        _this.placeholder = React.createRef();
        _this.content = null;
        _this.clientWidth = window.innerHeight || document.body.clientHeight;
        return _this;
    }
    Affix.prototype.componentDidMount = function () {
        var _this = this;
        // 未指定滚动容器
        if (this.props.target() === document.body) {
            window.addEventListener('scroll', function (evt) {
                var currentTarget = evt.currentTarget;
                var sTop = getScrollTop(currentTarget);
                _this.handleContainerEvent({
                    scrollTop: sTop,
                    eventSource: _this.props.target(),
                });
            });
        }
        else {
            // 指定滚动容器
            this.props.target().addEventListener('scroll', function (evt) {
                var currentTarget = evt.currentTarget;
                var sTop = getScrollTop(currentTarget);
                _this.handleContainerEvent({
                    scrollTop: sTop,
                    eventSource: _this.props.target(),
                });
            });
        }
        if (this.placeholder.current) {
            this.timer = setTimeout(function () {
                var initSticky = _this.props.initFixed && _this.clientWidth < getOffsetTop(_this.placeholder.current);
                _this.setState({
                    isSticky: initSticky,
                    wasSticky: initSticky,
                    style: initSticky
                        ? {
                            position: 'fixed',
                            transform: 'translateZ(0)',
                            top: typeof _this.props.offsetTop !== 'undefined' && _this.props.offsetTop >= 0
                                ? _this.props.offsetTop
                                : 'auto',
                            bottom: typeof _this.props.offsetBottom !== 'undefined' && _this.props.offsetBottom >= 0
                                ? _this.props.offsetBottom
                                : 'auto',
                        }
                        : {},
                });
            }, 0);
        }
    };
    Affix.prototype.componentDidUpdate = function () {
        if (this.placeholder.current) {
            this.placeholder.current.style.paddingBottom = (this.state.isSticky ? this.state.calculatedHeight : 0) + "px";
        }
    };
    Affix.prototype.componentWillUnmount = function () {
        if (this.timer)
            clearTimeout(this.timer);
        if (this.props.target() === document.body) {
            window.removeEventListener('scroll', function () { });
        }
        else {
            this.props.target().removeEventListener('scroll', function () { });
        }
    };
    Affix.prototype.renderContent = function () {
        var _this = this;
        var _a = this.props, children = _a.children, style = _a.style;
        var param = {
            style: this.state.style,
        };
        var stickyDivCls = ['z-50'];
        var element = (React.createElement(DivTag, __assign({ atomics: stickyDivCls, ref: function (content) {
                _this.content = content;
            } }, param), children));
        return (React.createElement(DivTag, { atomics: [], className: this.props.className, style: style },
            React.createElement(DivTag, { atomics: [], ref: this.placeholder }),
            element));
    };
    Affix.prototype.render = function () {
        return React.createElement(React.Fragment, null, this.renderContent());
    };
    Affix.NAME = 'affix';
    Affix.displayName = 'Affix';
    Affix.defaultProps = defaultProps;
    return Affix;
}(PureComponent));
export { Affix };
